import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {FillObject} from '@PosterWhiteboard/classes/fill.class';

export function useGetKeyFromFillOfBackgroundOfActiveItem<T extends keyof FillObject>(key: T): FillObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'background' in item && item.background.fill[key] !== undefined) {
      return item.background.fill[key];
    }

    return undefined;
  });
}
